module.exports = __webpack_public_path__ + "media/images/menu-home-active-icon-095fa94a747b9716519b84fe6702939d.svg";